import axios from 'axios';
import s3Object from '../service/s3getObject';
import { Option } from '../types/option';

const BASE_URL = '/api/medias';
type MediaId = number;

export type Media = {
    id: MediaId;
    url: string;
    priority: number;
};

export function imageSrc(media: Media): string {
    return s3Object(media.url);
}

export function mediaExtension(media: Option<Media>): Option<string> {
    return media
        .filter(media => media.url.trim() !== '')
        .map(media => mediaUrlExtension(media.url));
}

export function mediaUrlExtension(url: string): string {
    const lastDot = url.lastIndexOf('.');
    return lastDot === -1 ? '' : url.slice(lastDot + 1);
}

export function buildMediaStorageKey(media: string, extension: string): string {
    const trimmedMedia = media.trim();
    const trimmedExtension = extension.trim();

    if (!trimmedMedia) {
        return '';
    }

    if (!trimmedExtension) {
        return trimmedMedia;
    }

    const normalizedExtension = normalizeMediaExtension(trimmedExtension);
    const extensionSuffix = `.${normalizedExtension}`;

    if (trimmedMedia.toLowerCase().endsWith(extensionSuffix)) {
        return trimmedMedia;
    }

    if (normalizedExtension === 'jpg' && /\.jpe?g$/i.test(trimmedMedia)) {
        return trimmedMedia;
    }

    const lastDot = trimmedMedia.lastIndexOf('.');
    if (lastDot > 0 && lastDot < trimmedMedia.length - 1) {
        return trimmedMedia;
    }

    return `${trimmedMedia}${extensionSuffix}`;
}

export function isJpgMediaExtension(extension: string): boolean {
    const normalized = extension.toLowerCase();
    return normalized === 'jpg' || normalized === 'jpeg';
}

export function normalizeMediaExtension(extension: string): string {
    const normalized = extension.toLowerCase();
    if (normalized === 'jpeg') {
        return 'jpg';
    }

    return normalized;
}

export async function postMedia(url: string, file: File, priority: number): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('priority', String(priority));
    await axios.post(url, formData);
}

export async function updateMedia(mediaId: MediaId, file: File, priority: number): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('priority', String(priority));
    await axios.post(`${BASE_URL}/${mediaId}`, formData);
}

export async function deleteMedia(mediaId: MediaId): Promise<void> {
    await axios.delete(`${BASE_URL}/${mediaId}`);
}
